module.exports = __webpack_public_path__ + "media/images/flags/4x3/grd-d1128053016c878f9d582c6584171070.svg";